/**
 * Adds the given opacity to the given HEX color.
 *
 * @opacity a number from 0-1.
 */
export const alpha = (hex: string, opacity: number) =>
  `${hex}${Math.floor(opacity * 255)
    .toString(16)
    .padStart(2, '0')}`;

/**
 * Lightens a given HEX color by the given percent.
 * This can also be used to darken a color by providing a negative percent
 *
 * Adapted from an answer here:
 * https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
 *
 * @example
 * lighten('#ffffff', -20) => "#ebebeb"
 */
export function lighten(color: string, percent: number) {
  const hexValues = [
    color.substring(1, 3), // R
    color.substring(3, 5), // G
    color.substring(5, 7), // B
  ];

  const adjustedHexValues = hexValues.map((colorValue) => {
    const hexColorValue = parseInt(colorValue, 16);
    const adjustedHexColorValue = (hexColorValue * (100 + percent)) / 100;
    // Hex can never be more than 255
    const roundedHexColorValue = Math.min(
      255,
      Math.round(adjustedHexColorValue),
    );
    const paddedHexColorValue = roundedHexColorValue
      .toString(16)
      .padStart(2, '0');
    return paddedHexColorValue;
  });

  return '#' + adjustedHexValues.join('');
}
